const EVENTS = {
  ANSWER: "ANSWER",
  ANIMATION_DONE: "ANIMATION_DONE",
  NEW_STEP_LOADED: "NEW_STEP_LOADED",
  RESET: "RESET",
}

const STATES = {
  QUESTION: "QUESTION",
  NEXT: "NEXT",
  PREV: "PREV",
  ANIMATE_OUT: "ANIMATE_OUT",
  ANIMATE_IN: "ANIMATE_IN",
}

const MACHINE = {
  initial: STATES.QUESTION,
  states: {
    [STATES.QUESTION]: {
      on: {
        [EVENTS.ANSWER]: STATES.ANIMATE_OUT,
        [EVENTS.PREV]: STATES.ANIMATE_OUT,
        [EVENTS.RESET]: STATES.QUESTION,
      },
    },
    [STATES.ANIMATE_OUT]: {
      on: {
        [EVENTS.ANIMATION_DONE]: STATES.ANIMATE_IN,
      },
    },
    [STATES.ANIMATE_IN]: {
      on: {
        [EVENTS.NEW_STEP_LOADED]: STATES.QUESTION,
      },
    },
  },
}

const QUESTIONS = {
  1: {
    question: "Hur många blöjbyten genererar en genomsnittsbebis per år?",
    answers: [
      { value: 1, text: "2700" },
      { value: 2, text: "950" },
      { value: 3, text: "1800" },
    ],
  },
  2: {
    question: "Hur kurar du en ullblöja?",
    answers: [
      { value: 1, text: "Du tvättar den med ullanpassat tvättmedel" },
      { value: 2, text: "Du doftbehandlar den med lavendel" },
      { value: 3, text: "Du återfettar den med lanolin" },
    ],
  },
  3: {
    question: "När får en bebis knäskålar?",
    answers: [
      { value: 1, text: "Vid cirka 6 månaders ålder" },
      { value: 2, text: "Bebisar föds med knäskålar" },
      { value: 3, text: "Vid cirka 10 månaders ålder" },
    ],
  },
  4: {
    question: "I hur många olika färger kan du få Alma och Olmo blöjorna?",
    answers: [
      { value: 1, text: "12" },
      { value: 2, text: "10" },
      { value: 3, text: "8" },
    ],
  },
  5: {
    question: "Vilken månad på året föds de största bebisarna?",
    answers: [
      { value: 1, text: "Maj månad" },
      { value: 2, text: "Oktober månad" },
      { value: 3, text: "Det varierar från år till år" },
    ],
  },
  6: {
    question: "När börjar en bebis le?",
    answers: [
      { value: 1, text: "När de är cirka 3-4 veckor gamla" },
      { value: 2, text: "Bebisar ler redan i magen" },
      { value: 3, text: "Under det första levnadsdygnet" },
    ],
  },
  7: {
    answers: [],
    lastStep: true,
  },
}

const CORRECT_ANSWERS = [1, 3, 1, 2, 1, 2]

const DISCOUNT_CODES = {
  0: {
    text: "Försök igen!",
  },
  1: {
    text: "Försök igen!",
  },
  2: {
    text: "Försök igen!",
  },
  3: {
    text: "Helt ok! 5% rabatt!",
    code: "LKJASFD9234",
    validTo: "Rabattkoden gäller för obegränsat antal köp fram till och med 2020-08-01"
  },
  4: {
    text: "Det tar sig! 10% rabatt!",
    code: "UOIAHSF234E",
    validTo: "Rabattkoden gäller för obegränsat antal köp fram till och med 2020-08-01"
  },
  5: {
    text: "Bara ett fel! 15% rabatt!",
    code: "NASMKLFUOI1",
    validTo: "Rabattkoden gäller för obegränsat antal köp fram till och med 2020-08-01"
  },
  6: {
    text: "Wow, alla rätt! 20% rabatt!",
    code: "NVASCUIYWQ2",
    validTo: "Rabattkoden gäller för obegränsat antal köp fram till och med 2020-08-01"
  },
}

export { EVENTS, MACHINE, QUESTIONS, CORRECT_ANSWERS, DISCOUNT_CODES }
